import React from 'react';
import graph from './graph';
import Update from './Update';
import Package from './Package';
import Wholesale from './Wholesale';
import Attributes from './Attributes';

import { AvatarPopover, CustomList, NewMediaPopup } from 'components';
import { addCommas, digitsEnToFa } from '@persian-tools/persian-tools';
import { Fade, Card, Stack, Typography, CardHeader, CardActions, CardActionArea, CardContent } from '@mui/material';

export default function Model({ model, delay, checked, refetch, isAssign, selectable, handleSelect }) {
  const { id, shop, booth, product_info, co_price, me_price, stock, attributes } = model;
  const { title, barcode, brand, category, media, introtext, packaged_items } = product_info;
  const productTitle = `${title}`;
  return (
    <>
      <Fade in unmountOnExit timeout={{ appear: delay * 150, enter: delay * 170, exit: delay * 190 }}>
        <Stack direction="row" alignItems="center">
          <Card
            sx={{
              width: '100%',
              position: 'relative',
              borderColor: checked && 'primary.main',
              bgcolor: checked && 'action.disabledBackground',
            }}
            variant="outlined"
          >
            <CardHeader
              sx={{ p: 1 }}
              avatar={
                <NewMediaPopup
                  id={product_info.id}
                  model="Product"
                  collection="avatar"
                  title={productTitle}
                  subheader={`${brand?.title} ${barcode}` || 'محصول'}
                  graph={graph}
                >
                  <AvatarPopover isAssign={isAssign} sx={{ width: 48, height: 48 }} media={media[0]?.full_url} />
                </NewMediaPopup>
              }
              title={
                <Stack rowGap={0.5} alignItems="flex-start">
                  <Typography variant="subtitle1">{productTitle}</Typography>
                </Stack>
              }
              subheader={brand?.title || ''}
              action={
                <Typography fontSize={12} variant="subtitle2" color="text.disabled">
                  {digitsEnToFa(introtext || '')}
                </Typography>
              }
            />
            <CardContent sx={{ p: 1 }}>
              <CustomList
                data={{
                  title: `${shop?.title} - ${booth?.title}`,
                  value: stock,
                  unit: 'عدد',
                  children: [
                    {
                      title: 'کارخانه',
                      value: addCommas(Number(co_price)),
                      unit: 'تومان',
                    },
                    {
                      title: 'فروشگاه',
                      value: addCommas(Number(me_price)),
                      unit: 'تومان',
                    },
                    {
                      title: 'بارکد',
                      value: barcode,
                      unit: '',
                    },
                  ],
                }}
              />
            </CardContent>
            <CardActions sx={{ justifyContent: 'flex-end' }}>
              <Wholesale ids={id} refetch={refetch} />
              <Attributes ids={id} refetch={refetch} />
              {packaged_items.length > 0 ? (
                <Package ids={id} refetch={refetch} />
              ) : (
                <Update ids={id} refetch={refetch} />
              )}
            </CardActions>
            <CardActionArea
              sx={{
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                zIndex: 1,
                position: 'absolute',
              }}
              disabled={!isAssign && !selectable}
              onClick={handleSelect}
            />
          </Card>
        </Stack>
      </Fade>
    </>
  );
}
